
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cultural-objects",
      function () {
        return require("private-next-pages/cultural-objects/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cultural-objects"])
      });
    }
  